import React, { useContext, useEffect, useState, useCallback } from "react";
import ContentLayout from "../../component/ContentLayout";
import axios from "../../util/axios";
import AgGridTable from "../../component/AgGridTable";
import moment from "moment";
import { Context } from "../../component/Context/ErrorContext";
import EditIcon from "@mui/icons-material/Edit";
import CloseIcon from "@mui/icons-material/Close";
import CustomButton from "../../component/Button";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";
import { BsSend } from "react-icons/bs";
import * as Yup from "yup";
import { useFormik } from "formik";
import { Grid, Switch } from "@mui/material";
import CustomTextField from "../../component/TextField";
import CustomModal from "../../component/Modal";
import TextEditor from "../../component/TextEditor";
import PhoneInput from "../../component/PhoneInput";
import { VscLoading } from "react-icons/vsc";
import { FaFilter } from "react-icons/fa";
import { IoIosSend } from "react-icons/io";
import { isOnlyCountryCode } from "../../util/util";
import { IoChevronDown, IoChevronUp } from "react-icons/io5";

const color: any = {
  active: "border-green text-green",
  pending: "border-pending text-pending",
  invited: "border-invited text-invited",
  activeBg: "bg-green text-green",
  pendingBg: "bg-pending text-pending",
  invitedBg: "bg-invited text-invited",
};

const tabs = [
  { id: 1, name: "SMS", key: "text" },
  { id: 2, name: "Email", key: "email" },
];

const msg: any = {
  text: "You have been added to by your administrator. To complete your registration and get started, please click the link below:",
  email: `<p style="font-size: 16px; line-height: 1.5; margin-bottom: 15px;">
      You have been added to <strong></strong> by your administrator. To complete your registration and get started, please click the link below:
    </p>`,
};

const statuses = ["invited", "pending", "active"];
const searchFields = ["name", "email", "phone"];

const statusesNew = ["invited", "pending"];

const Employee = () => {
  const navigate = useNavigate();
  const { setError } = useContext(Context);
  const [loading, setLoading] = useState(false);
  const [allEmployees, setAllEmployees] = useState<any>([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [isEmployeeEdit, setIsEmployeeEdit] = useState(false);
  const [isInvite, setIsInvite] = useState(false);
  const [colDefs, setCol] = useState<any>([]);
  const [activeTab, setActiveTab] = useState("");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [total, setTotal] = useState(0);
  const [filterStatus, setFilterStatus] = useState("");
  const [inviteAllModal, setInviteAllModal] = useState(false);
  const [country, setCountry] = useState<any>({});
  const [filterStartDate, setFilterStartDate] = useState<any>();
  const [filterEndDate, setFilterEndDate] = useState<any>();
  const [filterSearchField, setFilterSearchField] = useState("");
  const [filterSearchValue, setFilterSearchValue] = useState("");
  const [searchValue, setSearchValue] = useState("");
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [checkinSessionsModal, setCheckinSessionsModal] = useState(false);
  const [checkinSessions, setCheckinSessions] = useState<any>(null);
  const [checkinLoading, setCheckinLoading] = useState(false);
  const [expandedDates, setExpandedDates] = useState<Set<string>>(new Set());
  const [selectedUserEmail, setSelectedUserEmail] = useState("");
  const [checkinPage, setCheckinPage] = useState(1);

  const defaultInviteMessage = {
    user_id: "",
    channel: "text",
    body: "You have been added to by your administrator. To complete your registration and get started, please click the link below:",
    subject: "Top 5 Traffic Tips",
    status: "",
  };
  const [inviteMessage, setInviteMessage] = useState<any>(defaultInviteMessage);

  const sendInvite = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    if (inviteAllModal) {
      await axios({
        URL: `/omw/subadmin-inviteUser?channels=${inviteMessage.channel}&status=${inviteMessage.status}`,
        method: "POST",
      })
        .then(() => {
          setInviteMessage(defaultInviteMessage as any);
          setInviteAllModal(false);
          setModalVisible(false);
          setIsInvite(false);
        })
        .catch((error) => setError(error?.response?.data?.message))
        .finally(() => setLoading(false));
    } else {
      const payload = { ...inviteMessage };
      delete payload.status;

      await axios({
        URL: `/omw/subadmin-inviteUser`,
        method: "POST",
        data: payload,
      })
        .then(() => {
          const id = inviteMessage.user_id;
          if (id) {
            setAllEmployees((prev: any) =>
              [...prev].map((employee) =>
                employee.id === id
                  ? { ...employee, status: "active" }
                  : { ...employee },
              ),
            );
          }
          setInviteMessage(defaultInviteMessage as any);
          setModalVisible(false);
          setIsInvite(false);
        })
        .catch((error) => setError(error?.response?.data?.message))
        .finally(() => setLoading(false));
    }
  };

  useEffect(() => {
    const search = setTimeout(() => {
      setSearchValue(filterSearchValue);
    }, 500);
    return () => {
      clearTimeout(search);
    };
  }, [filterSearchValue]);

  const fetchCheckinSessions = useCallback(async (email: string, page: number = 1) => {
    if (!email) {
      console.error("Email is required");
      return;
    }
    setCheckinLoading(true);

    try {
      const result = await axios({
        URL: `/omw/subadmin/user-checkin-sessions?email=${encodeURIComponent(email)}&limit=10&page=${page}`,
        method: "POST",
      });
      if (result?.data?.data) {
        setCheckinSessions(result.data.data);
        // Sync page state with API response
        if (result.data.data.pagination) {
          setCheckinPage(result.data.data.pagination.page);
        }
        // Expand first date by default
        if (result.data.data.dates && result.data.data.dates.length > 0) {
          setExpandedDates(new Set([result.data.data.dates[0].date]));
        }
      }
    } catch (error: any) {
      if (error.response?.status === 404) {
        setCheckinSessions({ error: "User is not registered yet" });
      } else {
        setError(error.response?.data?.message || "Failed to fetch checkin sessions");
      }
    } finally {
      setCheckinLoading(false);
    }
  }, [setError]);

  const handleViewCheckinSessions = useCallback(async (email: string) => {
    console.log("Opening checkin sessions for:", email);
    setSelectedUserEmail(email);
    setCheckinSessionsModal(true);
    setCheckinSessions(null);
    setExpandedDates(new Set());
    setCheckinPage(1);
    await fetchCheckinSessions(email, 1);
  }, [fetchCheckinSessions]);

  const handleCheckinPageChange = useCallback((newPage: number) => {
    if (selectedUserEmail) {
      setCheckinPage(newPage);
      setExpandedDates(new Set());
      fetchCheckinSessions(selectedUserEmail, newPage);
    }
  }, [selectedUserEmail, fetchCheckinSessions]);

  const handleLoneWorkerToggle = useCallback(async (userId: number, currentValue: boolean) => {
    const newValue = !currentValue;
    try {
      setLoading(true);
      await axios({
        URL: `/omw/subAdmin/User/${userId}`,
        method: "PATCH",
        data: {
          is_loneworker: newValue,
        },
      });
      // Update local state immediately for better UX
      setAllEmployees((prev: any) =>
        prev.map((employee: any) =>
          employee.id === userId
            ? { ...employee, is_loneworker: newValue }
            : employee,
        ),
      );
      setError("Lone worker status updated successfully!");
    } catch (error: any) {
      setError(error.response?.data?.message || "Failed to update lone worker status");
      // Revert the change on error by refetching
      fetchEmployeeData(
        page,
        pageSize,
        filterStatus,
        filterStartDate,
        filterEndDate,
        filterSearchField,
        searchValue,
      );
    } finally {
      setLoading(false);
    }
  }, [page, pageSize, filterStatus, filterStartDate, filterEndDate, filterSearchField, searchValue, setError]);

  useEffect(() => {
    if (allEmployees.length) {
      setCol([
        {
          field: "name",
          headerName: "NAME",
          cellRenderer: (param: any) => {
            const email = param?.data?.email;
            return (
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <VisibilityIcon
                  className={"cursor-pointer"}
                  onClick={() => navigate(`/employee/${param?.data?.id}`)}
                  component="svg"
                />
                <span 
                  className="cursor-pointer hover:text-sidebarSelectText"
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    if (email) {
                      handleViewCheckinSessions(email);
                    }
                  }}
                  style={{ cursor: "pointer" }}
                >
                  {param.value}
                </span>
              </div>
            );
          },
          cellStyle: {
            display: "flex",
            alignItems: "center",
            gap: "10px",
          },
        },
        {
          field: "email",
          headerName: "EMAIL",
          cellRenderer: (param: any) => {
            const email = param.value;
            return (
              <span 
                className="cursor-pointer hover:text-sidebarSelectText"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  if (email) {
                    handleViewCheckinSessions(email);
                  }
                }}
                style={{ cursor: "pointer" }}
              >
                {email}
              </span>
            );
          },
          cellStyle: {
            display: "flex",
            alignItems: "center",
          },
        },
        {
          field: "phone",
          headerName: "MOBILE NUMBER",
          cellRenderer: (param: any) => {
            return <p>{param.value}</p>;
          },
          cellStyle: {
            display: "flex",
            alignItems: "center",
          },
        },
        {
          field: "status",
          headerName: "STATUS",
          cellRenderer: (params: { value: string }) => {
            return (
              <div
                className={`w-fit flex items-center border border-solid ${
                  color[params.value.toLowerCase() as string]
                } rounded-xl px-4 py-1 !h-[25px] text-sm font-semibold gap-1`}
              >
                <div
                  className={`w-[6px] h-[6px] ${
                    color[(params.value.toLowerCase() as string) + "Bg"]
                  } rounded-full`}
                />
                {params.value[0].toUpperCase() +
                  params.value.slice(1, params.value.length)}
              </div>
            );
          },
          cellStyle: {
            display: "flex",
            alignItems: "center",
          },
        },
        {
          field: "created_dt",
          headerName: "DATE",
          cellRenderer: (params: { value: string }) => {
            return (
              <div className={"flex items-center"}>
                <p>{moment(params.value).format("MM/DD/YYYY")}</p>
              </div>
            );
          },
          cellStyle: {
            display: "flex",
            alignItems: "center",
          },
        },
        {
          field: "is_loneworker",
          headerName: "LONE WORKER",
          cellRenderer: (param: any) => {
            const isLoneWorker = param?.data?.is_loneworker || false;
            const userId = param?.data?.id;
            return (
              <div className={"h-full flex items-center justify-center"}>
                <Switch
                  checked={isLoneWorker}
                  onChange={() => handleLoneWorkerToggle(userId, isLoneWorker)}
                  disabled={loading}
                  sx={{
                    "& .MuiSwitch-switchBase.Mui-checked": {
                      color: "#5f6e85",
                    },
                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                      backgroundColor: "#5f6e85",
                    },
                  }}
                />
              </div>
            );
          },
          cellStyle: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          },
        },
        {
          field: "action",
          headerName: "Action",
          cellRenderer: (param: any) => {
            return (
              <div className={"h-full flex items-center gap-4"}>
                <BsSend
                  className={"text-primaryText cursor-pointer"}
                  onClick={() => {
                    setActiveTab("text");
                    setInviteMessage((prev: any) => ({
                      ...prev,
                      channel: "text",
                      user_id: param?.data?.id,
                    }));
                    setIsEmployeeEdit(true);
                    setModalVisible(true);
                    setIsInvite(true);
                  }}
                  title={"Invite"}
                />
                <EditIcon
                  className={"text-primaryText cursor-pointer"}
                  onClick={() => {
                    setIsEmployeeEdit(true);
                    setModalVisible(true);
                    setValues(param?.data);
                  }}
                  titleAccess={"Edit"}
                />
                <CloseIcon
                  className={"text-red-600 cursor-pointer"}
                  onClick={() => deleteEmployee(param?.data?.id)}
                  titleAccess={"Delete"}
                />
              </div>
            );
          },
          cellStyle: {
            display: "flex",
            alignItems: "center",
          },
        },
      ]);
    }
  }, [allEmployees, navigate, handleViewCheckinSessions, loading, handleLoneWorkerToggle]);

  useEffect(() => {
    fetchEmployeeData(
      page,
      pageSize,
      filterStatus,
      filterStartDate,
      filterEndDate,
      filterSearchField,
      searchValue,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    page,
    pageSize,
    filterStatus,
    filterStartDate,
    filterEndDate,
    filterSearchField,
    searchValue,
  ]);

  const fetchEmployeeData = async (
    page = 1,
    pageSize = 10,
    status = "",
    filterStartDate = "",
    filterEndDate = "",
    filterSearchField = "",
    searchValue = "",
  ) => {
    const url = `/omw/subAdmin/Users?page=${page}&limit=${pageSize}&status=${status}&search_field=${filterSearchField}&search_value=${searchValue}&start_date=${filterStartDate}&end_date=${filterEndDate}`;
    try {
      setLoading(true);
      const result = await axios({
        URL: url,
        method: "GET",
      });
      if (result?.data?.data) {
        setAllEmployees(result.data.data.users || []);
        setTotal(result.data.data.total || 0);
      }
    } catch (error: any) {
      setError(error.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    email: Yup.string().required("Email is required"),
    phone: Yup.string().required("phone is required"),
  });

  const formik = useFormik({
    initialValues: {
      id: 0,
      name: "",
      email: "",
      phone: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values, { setFieldError }) => {
      try {
        if (values.phone === "" || isOnlyCountryCode(values.phone, country)) {
          setFieldError("phone", "Required");
        } else {
          axios(
            isEmployeeEdit
              ? {
                  URL: `/omw/subAdmin/User/${values?.id}`,
                  method: "PATCH",
                  data: values,
                }
              : {
                  URL: "/omw/subAdmin/createUser",
                  method: "POST",
                  data: values,
                },
          )
            .then(() => {
              resetForm();
              setModalVisible(false);
              fetchEmployeeData();
            })
            .catch((err) => setError(err.response?.data?.message));
        }
      } catch (error) {}
    },
  });

  const {
    handleSubmit,
    values,
    setValues,
    handleChange,
    setFieldValue,
    resetForm,
    errors,
  } = formik;

  const deleteEmployee = (id: any) => {
    setLoading(true);
    axios({
      URL: `/omw/subAdmin/User/${id}`,
      method: "DELETE",
    })
      .then(() => {
        fetchEmployeeData();
      })
      .catch((err) => setError(err.response?.data?.message))
      .finally(() => setLoading(false));
  };

  const handleInviteChange = (e: any) => {
    setInviteMessage((prev: any) => ({
      ...prev,
      [e.target?.name]: e.target?.value,
    }));
  };

  const toggleDateExpansion = (date: string) => {
    setExpandedDates((prev) => {
      const newSet = new Set(prev);
      if (newSet.has(date)) {
        newSet.delete(date);
      } else {
        newSet.add(date);
      }
      return newSet;
    });
  };

  return (
    <ContentLayout
      className={"items-start rounded-3xl m-2 gap-6 overflow-y-scroll"}
    >
      <div className={"flex justify-between items-center w-full"}>
        <p className={"text-3xl font-bold text-primaryText"}>Employees</p>
        <div className={"flex gap-3 items-center"}>
          <IoIosSend
            onClick={(e) => {
              e.preventDefault();
              setActiveTab("text");
              setInviteMessage((prev: any) => ({
                ...prev,
                channel: "text",
                user_id: "",
                status: "invited",
              }));
              setIsEmployeeEdit(true);
              setModalVisible(true);
              setIsInvite(true);
              setInviteAllModal(true);
            }}
            className={"cursor-pointer text-white text-lg"}
          />
          <FaFilter
            onClick={() => setIsFilterOpen(!isFilterOpen)}
            className={"cursor-pointer text-white text-base"}
          />
          <CustomButton
            title={"Create Employee"}
            onClick={() => {
              setIsEmployeeEdit(false);
              setIsInvite(false);
              setModalVisible(true);
            }}
          />
        </div>
      </div>
      <div
        className={`flex justify-between items-center w-full ${isFilterOpen ? "block" : "hidden"}`}
      >
        <div className={"p-5 bg-primary rounded-lg w-full flex flex-col gap-4"}>
          <div className="w-full max-w-full gap-4 grid grid-cols-5">
            <div className={"flex flex-col gap-2 items-start w-full"}>
              <label htmlFor={"status"} className={"text-white text-xs"}>
                Status
              </label>
              <select
                id="status"
                className="w-full p-4 pr-12 bg-gray text-white rounded-[10px]"
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
              >
                {statuses.map((status) => (
                  <option key={status} value={status}>
                    {status}
                  </option>
                ))}
              </select>
            </div>
            <CustomTextField
              label={"Start Date"}
              placeholder={"Select Start Date"}
              type={"date"}
              name={"startDate"}
              value={filterStartDate}
              onChange={(e: any) => setFilterStartDate(e.target.value)}
              required
            />
            <CustomTextField
              label={"End Date"}
              placeholder={"Select End Date"}
              type={"date"}
              name={"endDate"}
              value={filterEndDate}
              onChange={(e: any) => setFilterEndDate(e.target.value)}
              required
            />
            <div className={"flex flex-col gap-2 items-start w-full"}>
              <label htmlFor={"searchField"} className={"text-white text-xs"}>
                Search Field
              </label>
              <select
                id="searchField"
                className="w-full p-4 pr-12 bg-gray text-white rounded-[10px]"
                value={filterSearchField}
                onChange={(e) => {
                  setFilterSearchField(e.target.value);
                  setFilterSearchValue("");
                }}
              >
                {searchFields.map((field) => (
                  <option key={field} value={field}>
                    {field === "phone" ? "mobile" : field}
                  </option>
                ))}
              </select>
            </div>
            <CustomTextField
              label={"Search Value"}
              placeholder={"Enter Search Value"}
              type={"text"}
              name={"searchValue"}
              value={filterSearchValue}
              onChange={(e: any) => setFilterSearchValue(e.target.value)}
              required
              disabled={filterSearchField === ""}
            />
          </div>
          <CustomButton
            className={"!w-fit"}
            title={"Reset"}
            onClick={() => {
              setFilterStatus("");
              setFilterStartDate("");
              setFilterEndDate("");
              setFilterSearchField("");
              setFilterSearchValue("");
              setIsFilterOpen(false);
            }}
          />
        </div>
      </div>
      <div className="ag-theme-quartz w-full h-full">
        <AgGridTable
          rowData={allEmployees}
          colDefs={colDefs}
          loading={loading}
          height={"95%"}
          bottomBorder={"#242A2F"}
          rowHeight={50}
          pagination={true}
          pageSize={pageSize}
          page={page}
          pageChange={setPage}
          pageSizeChange={setPageSize}
          total={total}
        />
      </div>
      <CustomModal
        open={modalVisible}
        onClose={() => {
          setModalVisible(false);
          setIsEmployeeEdit(false);
          setInviteMessage(defaultInviteMessage as any);
          setInviteAllModal(false);
          setIsInvite(false);
          resetForm();
        }}
        label={
          isEmployeeEdit
            ? isInvite
              ? inviteAllModal
                ? "Invite Employees"
                : "Invite Employee"
              : "Update Employee"
            : "Create Employee"
        }
      >
        {isInvite ? (
          <div className={"flex flex-col gap-3"}>
            {inviteAllModal && (
              <div className={"flex flex-col gap-1"}>
                <p className={"text-primaryText text-sm"}>Status</p>
                <select
                  className="px-2 py-2 rounded-2xl bg-gray text-white h-[54px]"
                  value={inviteMessage.status}
                  onChange={(e) => {
                    setInviteMessage((prev: any) => ({
                      ...prev,
                      status: e.target.value,
                    }));
                  }}
                >
                  {statusesNew.map((status) => (
                    <option key={status} value={status}>
                      {status}
                    </option>
                  ))}
                </select>
              </div>
            )}
            <div className={"flex flex-col gap-1"}>
              <p className={"text-primaryText text-sm"}>Invite Type</p>
              <div className={"flex w-full gap-1 bg-gray p-1 rounded-xl"}>
                {tabs.map((tab, index) => (
                  <div
                    key={tab.key}
                    className={`flex-1 flex justify-center items-center py-3 text-white font-medium rounded-xl cursor-pointer ${
                      activeTab === tab.key
                        ? "bg-primary"
                        : "bg-gray opacity-60"
                    }`}
                    onClick={() => {
                      setActiveTab(tab.key);
                      setInviteMessage((prev: any) => ({
                        ...prev,
                        channel: tab.key,
                        body: msg[tab.key],
                      }));
                    }}
                  >
                    {tab.name}
                  </div>
                ))}
              </div>
            </div>
            <form className={"flex flex-col gap-3"}>
              {!inviteAllModal && (
                <>
                  <div className={"flex flex-col gap-2 w-full"}>
                    <CustomTextField
                      label={"Subject"}
                      type={"text"}
                      name={"subject"}
                      onChange={(e: any) => handleInviteChange(e)}
                      value={inviteMessage?.subject}
                      disabled={loading}
                      required={activeTab === "email"}
                    />
                  </div>
                  <div className={"flex flex-col gap-2 w-full"}>
                    <CustomTextField
                      label={"Body"}
                      type={"textarea"}
                      name={"body"}
                      onChange={(e: any) => handleInviteChange(e)}
                      value={inviteMessage?.body}
                      multiline={true}
                      minRows={3}
                      className={`h-auto ${
                        activeTab === "email" ? "hidden" : "flex"
                      }`}
                      disabled={loading}
                      required={true}
                    />
                    {activeTab === "email" && (
                      <TextEditor
                        className={`${
                          activeTab === "email"
                            ? "flex flex-col h-[150px]"
                            : "hidden"
                        }`}
                        onChange={(value) => {
                          setInviteMessage((prev: any) => ({
                            ...prev,
                            body: value,
                          }));
                        }}
                        value={inviteMessage?.body}
                      />
                    )}
                  </div>
                </>
              )}
              <CustomButton
                title={
                  loading ? (
                    <VscLoading className={"animate-spin text-2xl"} />
                  ) : (
                    "Send"
                  )
                }
                onClick={(e: any) => sendInvite(e)}
                className={`!py-3 disabled:opacity-80 opacity-100 disabled:cursor-not-allowed`}
                disabled={loading}
              />
            </form>
          </div>
        ) : (
          <form
            onSubmit={handleSubmit}
            className={"flex flex-col mt-5 w-full max-w-full gap-4"}
            autoComplete={"off"}
          >
            <Grid
              container
              spacing={2}
              className={"overflow-auto max-h-[600px]"}
            >
              <Grid item xs={12} sm={8} md={12}>
                <CustomTextField
                  label={"Name"}
                  type={"text"}
                  name={"name"}
                  onChange={handleChange}
                  value={values?.name}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={8} md={12}>
                <CustomTextField
                  label={"Email"}
                  type={"text"}
                  name={"email"}
                  onChange={handleChange}
                  value={values?.email}
                  required
                />
              </Grid>
              <Grid item xs={12} sm={6} md={12}>
                <PhoneInput
                  label={"Phone"}
                  onChange={(v) => setFieldValue("phone", v)}
                  value={values?.phone}
                  countryChange={setCountry}
                  required
                  errorMsg={errors?.phone || ""}
                />
              </Grid>
            </Grid>
            <CustomButton
              title={
                isEmployeeEdit
                  ? isInvite
                    ? "Invite"
                    : "Update Employee"
                  : "Create Employee"
              }
              type={"submit"}
              className={"!py-3"}
            />
          </form>
        )}
      </CustomModal>

      {/* Checkin Sessions Modal */}
      <CustomModal
        open={checkinSessionsModal}
        onClose={() => {
          setCheckinSessionsModal(false);
          setCheckinSessions(null);
          setSelectedUserEmail("");
          setExpandedDates(new Set());
          setCheckinPage(1);
        }}
        label="Checkin-Checkout Sessions"
      >
        <div className="flex flex-col gap-4 mt-4" style={{ maxHeight: '70vh', display: 'flex', flexDirection: 'column' }}>
          {checkinLoading ? (
            <div className="flex justify-center items-center py-10">
              <VscLoading className="animate-spin text-2xl text-primaryText" />
            </div>
          ) : checkinSessions?.error ? (
            <div className="flex justify-center items-center py-10">
              <p className="text-primaryText text-lg">{checkinSessions.error}</p>
            </div>
          ) : checkinSessions?.dates && checkinSessions.dates.length > 0 ? (
            <>
              <div className="mb-2 flex-shrink-0">
                <p className="text-primaryText text-sm opacity-70">User: {checkinSessions.user?.email}</p>
              </div>
              <div 
                className="flex flex-col gap-3 overflow-y-auto flex-1 pr-2"
                style={{ 
                  maxHeight: 'calc(70vh - 120px)',
                  overflowY: 'auto',
                  scrollBehavior: 'smooth'
                }}
              >
                {checkinSessions.dates.map((dateItem: any, index: number) => {
                  const isExpanded = expandedDates.has(dateItem.date);
                  return (
                    <div
                      key={index}
                      className="bg-gray rounded-lg overflow-hidden flex-shrink-0"
                    >
                      <div
                        className="flex justify-between items-center p-4 cursor-pointer hover:bg-gray/80 transition-colors"
                        onClick={() => toggleDateExpansion(dateItem.date)}
                      >
                        <div className="flex items-center gap-3">
                          <p className="text-primaryText font-semibold">
                            {moment(dateItem.date).format("DD-MM-YYYY")}
                          </p>
                          <span className="text-grayLight text-sm">
                            ({dateItem.sessions.length} {dateItem.sessions.length === 1 ? "session" : "sessions"})
                          </span>
                        </div>
                        {isExpanded ? (
                          <IoChevronUp className="text-primaryText text-xl" />
                        ) : (
                          <IoChevronDown className="text-primaryText text-xl" />
                        )}
                      </div>
                      {isExpanded && (
                        <div className="border-t border-gray/30 p-4 flex flex-col gap-3">
                          {dateItem.sessions.map((session: any, sessionIndex: number) => (
                            <div
                              key={sessionIndex}
                              className="bg-primary rounded-lg p-4 flex flex-col gap-2"
                            >
                              <div className="grid grid-cols-2 gap-4">
                                <div>
                                  <p className="text-grayLight text-xs mb-1">Check-in Time</p>
                                  <p className="text-primaryText text-sm font-medium">
                                    {moment(session.checkin_time).format("DD-MM-YYYY hh:mm A")}
                                  </p>
                                </div>
                                <div>
                                  <p className="text-grayLight text-xs mb-1">Check-out Time</p>
                                  <p className="text-primaryText text-sm font-medium">
                                    {session.checkout_time 
                                      ? moment(session.checkout_time).format("DD-MM-YYYY hh:mm A")
                                      : "Not checked out"}
                                  </p>
                                </div>
                              </div>
                              {session.expired_checkin_time && (
                                <div>
                                  <p className="text-grayLight text-xs mb-1">Expired Check-in Time</p>
                                  <p className="text-primaryText text-sm">
                                    {moment(session.expired_checkin_time).format("DD-MM-YYYY hh:mm A")}
                                  </p>
                                </div>
                              )}
                              {session.checkout_time && (
                                <div className="mt-2 pt-2 border-t border-gray/20">
                                  <p className="text-grayLight text-xs">
                                    Duration: {moment(session.checkout_time).diff(moment(session.checkin_time), "minutes")} minutes
                                  </p>
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
              {checkinSessions.pagination && checkinSessions.pagination.totalPages > 1 && (
                <div className="flex justify-center items-center gap-4 pt-4 border-t border-gray/30 flex-shrink-0">
                  <button
                    onClick={() => handleCheckinPageChange(checkinSessions.pagination.page - 1)}
                    disabled={checkinSessions.pagination.page === 1 || checkinLoading}
                    className={`px-4 py-2 rounded-lg font-semibold text-sm ${
                      checkinSessions.pagination.page === 1 || checkinLoading
                        ? "bg-gray text-grayLight cursor-not-allowed"
                        : "bg-sidebarSelectText text-primaryText hover:bg-blue-600"
                    }`}
                  >
                    Previous
                  </button>
                  <span className="text-primaryText text-sm font-semibold">
                    Page {checkinSessions.pagination.page} of {checkinSessions.pagination.totalPages}
                  </span>
                  <button
                    onClick={() => handleCheckinPageChange(checkinSessions.pagination.page + 1)}
                    disabled={checkinSessions.pagination.page === checkinSessions.pagination.totalPages || checkinLoading}
                    className={`px-4 py-2 rounded-lg font-semibold text-sm ${
                      checkinSessions.pagination.page === checkinSessions.pagination.totalPages || checkinLoading
                        ? "bg-gray text-grayLight cursor-not-allowed"
                        : "bg-sidebarSelectText text-primaryText hover:bg-blue-600"
                    }`}
                  >
                    Next
                  </button>
                </div>
              )}
            </>
          ) : (
            <div className="flex justify-center items-center py-10">
              <p className="text-primaryText text-lg">No checkin sessions found</p>
            </div>
          )}
        </div>
      </CustomModal>
    </ContentLayout>
  );
};

export default Employee;
